export default "Mandataire CEE : estimation de vos primes, dépôt du dossier et suivi jusqu'au versement. 0 € d'avance. Résidentiel (BAR), tertiaire (BAT), industrie (IND), agriculture (AGRI).";
